const MapGettersCliente = {
    NOME_MODULO: "cliente",
    ID: "id"
};

const MapGettersModuleCliente = {
    ID: MapGettersCliente.NOME_MODULO + "/" + MapGettersCliente.ID
};

Object.freeze(MapGettersCliente);
Object.freeze(MapGettersModuleCliente);

export {MapGettersCliente, MapGettersModuleCliente};
